import { render, staticRenderFns } from "./set-diy-page.vue?vue&type=template&id=220b7b1e&scoped=true"
import script from "./set-diy-page.vue?vue&type=script&lang=ts"
export * from "./set-diy-page.vue?vue&type=script&lang=ts"
import style0 from "./set-diy-page.vue?vue&type=style&index=0&id=220b7b1e&prod&lang=scss&scoped=true"
import style1 from "./set-diy-page.vue?vue&type=style&index=1&id=220b7b1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220b7b1e",
  null
  
)

export default component.exports